var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOperandio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "GradientFill_1",
    cx: 26.59381,
    cy: -8.7675,
    r: 21.55608,
    gradientTransform: "translate(8.14022 8.14022) scale(0.45732 0.45732)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f26341"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f78f28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_2",
    x1: 20.32984,
    y1: 3.65282,
    x2: 28.07044,
    y2: 12.70076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f78f28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f26341"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "GradientFill_1-2",
    cx: 9.91054,
    cy: -6.92208,
    r: 24.16078,
    xlinkHref: "#GradientFill_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_2-2",
    x1: 16.22673,
    y1: 18.45931,
    x2: 20.44097,
    y2: 22.01422,
    xlinkHref: "#GradientFill_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_2-3",
    x1: 16.57389,
    y1: 23.89685,
    x2: 23.97323,
    y2: 32.03606,
    xlinkHref: "#GradientFill_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_2-4",
    x1: 7.93307,
    y1: 20.35007,
    x2: 10.19262,
    y2: 22.54173,
    xlinkHref: "#GradientFill_2"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "operandio") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.524,6.04589a2.93888,2.93888,0,0,0-.34428-.41348,13.30469,13.30469,0,0,0-9.23088-3.87076l-.03116-.00044L16.86594,1.761h-.03116l-.05169-.0002a13.1621,13.1621,0,0,0-5.04381,1.0083q-.40214.16654-.78984.35713A8.03244,8.03244,0,0,1,12.3622,5.38631a7.93808,7.93808,0,0,1,.60719,3.03929q0,.15212-.00606.30342a7.05735,7.05735,0,0,1,1.05292-.54491,7.34391,7.34391,0,0,1,2.81417-.5488h.00436l.043.00025h.00456a7.3425,7.3425,0,0,1-.0951,14.68464h-.00412L16.73992,22.32h-.00436a7.29933,7.29933,0,0,1-7.243-7.29729,8.08934,8.08934,0,0,1-1.41676.75913,7.92873,7.92873,0,0,1-3.03909.60747h-.081l-.0188-.00048a7.8636,7.8636,0,0,1-1.25428-.1116,13.33515,13.33515,0,0,0,3.41109,7.63256,2.92667,2.92667,0,0,0,.3444.4136A13.30513,13.30513,0,0,0,16.669,28.19386l.03092.00044.052.00025h.03116l.05169.0002a13.30349,13.30349,0,0,0,9.345-3.87141,2.96614,2.96614,0,0,0,.345-.41452A13.24127,13.24127,0,0,0,26.524,6.04589Z",
    fill: "#f63b3b",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9517,3.1287A13.23935,13.23935,0,0,1,25.22416,4.75183,2.93667,2.93667,0,0,1,21.49329,9.288,35.18045,35.18045,0,0,0,11.7388,4.17875,7.92716,7.92716,0,0,0,10.9517,3.1287Z",
    fillRule: "evenodd",
    fill: "url(#GradientFill_1)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.78977,5.37176c-.0196.02567-.03965.05121-.06047.07643a2.937,2.937,0,0,1-4.13323.40268,33.04691,33.04691,0,0,0-6.78173-3.95366q.36365-.056.73358-.09259a13.30065,13.30065,0,0,1,9.67624,2.94721A2.92082,2.92082,0,0,1,25.78977,5.37176Z",
    fillRule: "evenodd",
    fill: "url(#GradientFill_2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.18169,8.41853a34.53857,34.53857,0,0,0-5.266-2.50141,8.0041,8.0041,0,0,0-2.4785-.34339c-.02429-.06277-.04947-.12534-.075-.18742A8.13287,8.13287,0,0,0,11.739,4.179a36.01036,36.01036,0,0,1,9.43838,4.85757s-.02647-.018-.078-.0519A7.47113,7.47113,0,0,0,20.18169,8.41853Z",
    fillRule: "evenodd",
    fill: "url(#GradientFill_1-2)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.91747,21.72969c-2.10374-.322-5.87067-.47155-6.3206,2.71955a13.54352,13.54352,0,0,0,1.127.99137,13.18017,13.18017,0,0,0,17.52346-1.087,14.38051,14.38051,0,0,0,3.65077-7.68272c-.05994.20569-.02809.408-.07793.58663-1.24846,4.45859-7.22466,5.27717-11.91158,4.98055-.06463.00954-.12926.018-.194.02591A7.32115,7.32115,0,0,1,13.91747,21.72969Z",
    fillRule: "evenodd",
    fill: "url(#GradientFill_2-2)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14608,25.7589a13.17916,13.17916,0,0,0,17.02923-1.33314,15.25369,15.25369,0,0,1-3.29287.70917c-4.08659.4528-8.68188-.95815-11.30046-.571A3.78237,3.78237,0,0,0,9.14608,25.7589Z",
    fillRule: "evenodd",
    fill: "url(#GradientFill_2-3)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75879,19.11156c-3.76911-.29194-4.87082,1.444-5.15851,2.83021a13.18918,13.18918,0,0,0,1.99659,2.50747c.44993-3.1911,4.21743-3.04171,6.32105-2.71942A7.54085,7.54085,0,0,1,10.75879,19.11156Z",
    fillRule: "evenodd",
    fill: "url(#GradientFill_2-4)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7198,5.02554a1.116,1.116,0,0,0-.1312-.1573A5.06226,5.06226,0,0,0,5.07473,3.39473l-.01189-.00032H5.01163A5.06295,5.06295,0,0,0,1.45411,4.86824a1.09438,1.09438,0,0,0-.13108.15763,5.04,5.04,0,0,0,0,6.8,1.1239,1.1239,0,0,0,.13108.15731,5.06267,5.06267,0,0,0,3.514,1.47347l.01181.00036H5.0312a5.0625,5.0625,0,0,0,3.5574-1.47383,1.09721,1.09721,0,0,0,.1312-.15763,5.0405,5.0405,0,0,0,0-6.8Z",
    fill: "#fd9317",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperandio);
export default __webpack_public_path__ + "static/media/operandio.857111ace6cbd966c90301079c29fa15.svg";
export { ForwardRef as ReactComponent };